import React, {useEffect, useMemo} from "react";
import {NavLink} from 'react-router-dom';
import { Alert } from "@curves/ui-base";
import {CLUB_MEMBERS_ROUTER} from '@icoach/router/routerPath';
import {isEqual, mergeQueryToUrl} from "@util/utils";
import {MEMBER_DETAIL_TABS_MAP} from '@icoach/memberDetail/staticData';
import {TabsCardLayout} from '@icoach/components';
import useTabState from '@util/hook/useTabState';
import MemberDetailSmartFitnessBandContentDocument
    from "@icoach/memberDetail/MemberDetailSmartFitnessBandContentDocument";
import MemberDetailSmartFitnessBandContentBillingRecord
    from "@icoach/memberDetail/MemberDetailSmartFitnessBandContentBillingRecord";

import useMemberDeviceOrderApi from '@apis/useMemberDeviceOrderApi';

const tabData = [
    {
        label: '合約資訊',
        value: MEMBER_DETAIL_TABS_MAP.SFB_DOCUMENT,
    },
    {
        label: '收費明細',
        value: MEMBER_DETAIL_TABS_MAP.SFB_BILLING,
    },
];


/**
 * [元件] 會員詳細頁 > 智能系統區塊（Tab 版面）
 *
 * - 使用 TabsCardLayout 顯示「合約資訊」與「收費明細」兩個頁籤
 * - 支援切換 tab 狀態（使用 useTabState）
 * - 傳入 memberID，分別渲染對應資料元件
 * - 右上角有「新增租約」按鈕
 *
 * @component
 * @param {{ className?: string, memberID: string }} props
 */
const MemberDetailSmartFitnessBandContent = ({className, memberID}) => {
    const {activeTab, handleTabChange} = useTabState(MEMBER_DETAIL_TABS_MAP.SFB_DOCUMENT);

    const actionData = useMemo(() => {
        return [
            {
                label: '新增租約',
                variant: 'outlined',
                component: NavLink,
                to: mergeQueryToUrl(CLUB_MEMBERS_ROUTER.SMARTFITNESSBAND.CONTRACT_PATH(0), {memberID}),
            },
        ]
    }, [memberID])

    const {getMemberDeviceSubscriptionOrderCheckApi} = useMemberDeviceOrderApi();

    const [checkSubscription, setCheckSubscription] = React.useState({canUseDevice: true, canUseDeviceText: ""});

    const doGetMemberDeviceSubscriptionOrderCheckApi = async (memberID) => {
        try {
            const resp = await getMemberDeviceSubscriptionOrderCheckApi(memberID);
            if (resp) {
                setCheckSubscription({
                    canUseDevice: resp.canUseDevice,
                    canUseDeviceText: resp.canUseDeviceText
                });
            }
        } catch (error) {
            console.error('取得訂閱檢查失敗', error);
        }
    }

    useEffect(() => {
            memberID && doGetMemberDeviceSubscriptionOrderCheckApi(memberID);
        },
        // eslint-disable-next-line
        [memberID]);

    return (
        <TabsCardLayout
            className={className}
            activeTab={activeTab}
            tabs={tabData}
            actions={actionData}
            onTabChange={handleTabChange}
            tabsContent={{className: 'pt-3 px-3 pb-3'}}
        >
            {
                !checkSubscription?.canUseDevice && (
                    <Alert className="mb-4" color="warning" severity="warning" variant="filled">
                        {checkSubscription?.canUseDeviceText}
                    </Alert>
                )
            }
            {isEqual(activeTab, MEMBER_DETAIL_TABS_MAP.SFB_DOCUMENT) &&
                <MemberDetailSmartFitnessBandContentDocument memberID={memberID}/>}
            {isEqual(activeTab, MEMBER_DETAIL_TABS_MAP.SFB_BILLING) &&
                <MemberDetailSmartFitnessBandContentBillingRecord memberID={memberID}/>}
        </TabsCardLayout>
    );
};

export default MemberDetailSmartFitnessBandContent;
